/** A new id of a text box or an effect: letters and digits, inside the id rule of `coverDoc.ts`. */
export function newCoverItemId(prefix: 't' | 'fx'): string {
  const random =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID().replace(/-/g, '').slice(0, 12)
      : Math.random().toString(36).slice(2, 14);
  return `${prefix}_${random}`;
}
